function readLoginEmailFromProfile(profile: unknown): string | null {
    if (!profile || typeof profile !== 'object') return null;
    const le = (profile as { login_email?: unknown }).login_email;
    if (typeof le === 'string' && le.trim()) return le.trim();
    return null;
}

/**
 * Reads `profile.login_email` from legacy / v3 login payloads (array of outlets, single object, or nested `data`).
 */
export function getProfileLoginEmailFromAuthPayload(root: unknown): string | null {
    if (root == null) return null;

    if (Array.isArray(root)) {
        for (const row of root) {
            if (row && typeof row === 'object' && 'profile' in row) {
                const em = readLoginEmailFromProfile((row as { profile: unknown }).profile);
                if (em) return em;
            }
        }
        return null;
    }

    if (typeof root !== 'object') return null;

    const o = root as Record<string, unknown>;

    const fromProfile = readLoginEmailFromProfile(o.profile);
    if (fromProfile) return fromProfile;

    const data = o.data;
    if (data != null && data !== root) {
        const nested = getProfileLoginEmailFromAuthPayload(data);
        if (nested) return nested;
    }

    return null;
}
